import styled from "@emotion/styled";
import { Box } from "@mui/material";

const BaseDialogBgImage = styled("img")({
  height: "auto",
  left: 2,
  position: "absolute",
  top: 2,
  width: "auto",
  zIndex: 1
});

const BaseDialogIconContainer = styled(Box)({
  left: "20px",
  position: "absolute",
  top: "20px",
  width: "auto",
  zIndex: 1
});

const BaseDialogOuterCircle = styled(Box)<{ color?: string }>(
  ({ color, theme }) => ({
    alignItems: "center",
    backgroundColor:
      color || `rgba(${theme.vars.palette.primary.mainChannel} / 0.08)`,
    borderRadius: "50%",
    display: "flex",
    height: "60px",
    justifyContent: "center",
    width: "60px"
  })
);

const BaseDialogInnerCircle = styled(Box)<{ color?: string }>(
  ({ color, theme }) => ({
    alignItems: "center",
    backgroundColor: color || theme.vars.palette.primary.main,
    borderRadius: "50%",
    display: "flex",
    height: "40px",
    justifyContent: "center",
    width: "40px",
    zIndex: 0
  })
);

export {
  BaseDialogBgImage,
  BaseDialogIconContainer,
  BaseDialogOuterCircle,
  BaseDialogInnerCircle
};
